<template>
  <div>
    <div class="careers-page">
      <div class="positions-wrapper">
        <div v-for="(item, id) in jobs" :key="id" class="job-button text-left">
          <h5>{{ item.title }}</h5>
          <i class="fas fa-globe-americas trilon-pink"></i
          ><span class="job-location">{{ item.location }}</span>
          <button @click="setActive(id)" class="btn btn-secondary btn-more">
            Read more
            <arrow class="arrow-down" />
          </button>
        </div>
      </div>
      <div id="job-description">
        <div class="job-details col-12 text-left" v-if="selectedJob">
          <h2 v-html="selectedJob.title"></h2>

          <blockquote
            v-if="selectedJob.requiredLanguage"
            class="mt-5 note alternate"
          >
            Note: Only canidates fluent verbally & writtenly will be
            applicable.<br /><br />
            <strong>REQUIRED language:</strong>
            {{ selectedJob.requiredLanguage }}
          </blockquote>

          <h3>Location: {{ selectedJob.location }}</h3>

          <p>
            <strong>Language(s):</strong> {{ selectedJob.language }}<br />
            <strong>Position:</strong> {{ selectedJob.type }}<br />
          </p>

          <h3>Job Description:</h3>
          <p v-html="selectedJob.description"></p>

          <h3>Required Skills:</h3>
          <ul>
            <li v-for="(item, id) in selectedJob.skillsRequired" :key="id">
              <span><i class="fas fa-check"></i></span>
              {{ item }}
            </li>
          </ul>

          <h3>Nice to have / Bonus Points:</h3>
          <ul>
            <li v-for="(item, id) in selectedJob.niceToHave" :key="id">
              <span><i class="fas fa-check"></i></span>
              {{ item }}
            </li>
          </ul>

          <h3>Responsibilities:</h3>
          <ul>
            <li v-for="(item, id) in selectedJob.responsibilities" :key="id">
              <span><i class="fas fa-check"></i></span>
              {{ item }}
            </li>
          </ul>

          <hr />

          <!-- About Trilon -->
          <h3>About Trilon</h3>

          <p>
            At Trilon, we help elevate and empower teams - giving them the push
            they need to truly suceed in today's ever-changing tech world.
          </p>

          <p>
            Join our growing talented distributed team and work with modern
            tools, challenging projects, and help change the future of
            open-source.
          </p>
          <!-- About Trilon -->

          <h3>What We Offer:</h3>
          <ul>
            <li>
              <span><i class="fas fa-check"></i></span> Remote position - work
              wherever!
            </li>
            <li>
              <span><i class="fas fa-check"></i></span> Flexible working hours
            </li>
            <li>
              <span><i class="fas fa-check"></i></span> Help push Open-Source
              further
            </li>
            <li>
              <span><i class="fas fa-check"></i></span> Competitive Salaries
            </li>
          </ul>
          <p class="mt-5">
            Only submissions in English please.
            <br /><br />
            <strong>NO Agencies please.</strong>
          </p>
          <a
            :href="
              'mailto:hello@trilon.io?subject=Trilon Careers - ' +
              selectedJob.titleNoTags +
              ' &body=Inquiring about the position: ' +
              selectedJob.titleNoTags +
              '%0D%0A%0D%0APlease attach Resume/CV %0D%0A%0D%0APlease fill in all that is applicable:%0D%0A%0D%0A------------%0D%0A%0D%0ACurrent Location:%0D%0A%0D%0ALinkedIn Profile:%0D%0A%0D%0AGithub Profile:%0D%0A%0D%0AWebsite Portolio:%0D%0A%0D%0AOther Links: (Conference talks / blog posts / etc)'
            "
            class="btn btn-secondary mt-4"
            >Apply to job</a
          >
        </div>
      </div>
    </div>

    <div class="join-trilon">
      <div class="gradient-wrapper text-center">
        <div class="join-wrapper">
          <h2>
            Interested in joining the Team<span class="trilon-pink">?</span>
          </h2>
          <p class="pt-3">
            Our Team spans all across the globe, with a wide range of expertise
            from everything from design to devops.
          </p>
          <br />
          <a
            :href="'mailto:hello@trilon.io?subject=Trilon Careers&body=Inquiring about the position%0D%0A%0D%0APlease attach Resume/CV %0D%0A%0D%0APlease fill in all that is applicable:%0D%0A%0D%0A------------%0D%0A%0D%0ACurrent Location:%0D%0A%0D%0ALinkedIn Profile:%0D%0A%0D%0AGithub Profile:%0D%0A%0D%0AWebsite Portolio:%0D%0A%0D%0AOther Links: (Conference talks / blog posts / etc)'"
            class="btn btn-primary"
            >We'd love to hear from you!</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'pages',
  pageKey: 'careers',
  pageTitle: 'Careers at Trilon',
});
const { $store: store, ...rest } = useNuxtApp();

onMounted(() => {
  document.addEventListener('DOMContentLoaded', (ev) => {
    const hash = window.location.hash;
    if (hash) {
      // setTimeout(() => {
        // $scrollTo(hash, 500, { offset: -25 });
      // }, 200);
    }
  });
});

const structuredData = ref({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://trilon.io/#organization',
      name: 'Trilon',
      url: 'https://trilon.io/',
      sameAs: [],
      logo: {
        '@type': 'ImageObject',
        '@id': 'https://trilon.io/#logo',
        url: 'https://trilon.io/trilon-logo-clear.png',
        caption: 'Trilon',
      },
      image: {
        '@id': 'https://trilon.io/#logo',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://trilon.io/#website',
      url: 'https://trilon.io/',
      name: 'Trilon',
      publisher: {
        '@id': 'https://trilon.io/#organization',
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://trilon.io/?search={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://trilon.io/blog#webpage',
      url: 'https://trilon.io/blog',
      inLanguage: 'en-US',
      name: 'Next-level consulting from NestJS and Angular Universal core team members.',
      isPartOf: {
        '@id': 'https://trilon.io/#website',
      },
      about: {
        '@id': 'https://trilon.io/#organization',
      },
      image: {
        '@type': 'ImageObject',
        '@id': 'https://trilon.io/#primaryimage',
        url: 'https://trilon.io/meta/og-image.png',
        caption: 'Trilon',
      },
      primaryImageOfPage: {
        '@id': 'https://trilon.io/#primaryimage',
      },
      datePublished: '2019-02-24T10:30:12+00:00',
      dateModified: '2019-07-17T11:28:59.031Z',
      description:
        'Next-level consulting from NestJS and Angular Universal core team members. We give teams the push they need to truly succeed in today&#x27;s ever-changing world.',
    },
  ],
});
let activeId = ref(0);
let isOpenedMobile = ref(false);
const jobs = ref(store.openJobs);
let selectedJob = computed(() => {
  if (activeId.value !== null) {
    return store.openJobs[activeId.value || 0];
  }
  return null;
});

function setActive(id) {
  if (document) {
    const element = document.querySelector('#job-description');
    if ('scrollIntoView' in element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
  if (id === activeId.value) {
    isOpenedMobile.value = !isOpenedMobile.value;
  } else {
    isOpenedMobile.value = true;
  }
  activeId.value = id;
}

useHead({
  title: 'Careers',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content:
        'Careers at Trilon - Join our team and take on challenging projects, level-up teams, and shape the future of open source!',
    },
  ],
  __dangerouslyDisableSanitizers: ['script'],
  script: [
    {
      innerHTML: JSON.stringify(structuredData),
      type: 'application/ld+json',
    },
  ],
});
</script>

<style lang="scss" scoped>
.careers-page {
  max-width: 1000px;
  margin: 0 auto 5rem;
}

.job-button {
  border-radius: 10px;
  padding: 3rem;
  margin: 0 0 3rem;
  border-top: 10px #2a2256 solid;
  background: #130e28;
  position: relative;
  width: 100%;

  &:first-of-type {
    margin-top: 3rem;
  }

  .job-location {
    padding-left: 0.5rem;
  }

  .btn-more {
    position: absolute;
    right: 3rem;
    top: 2.7rem;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    .btn-more {
      position: static;
      display: block;
      margin-top: 2rem;
    }
  }
}

.join-trilon {
  max-width: 1000px;
  margin: 1rem auto 10rem;

  .gradient-wrapper {
    padding: 5px;
  }

  @media (max-width: 600px) {
    margin: 1rem auto 3rem;
  }
}
.join-wrapper {
  padding: 4rem 8rem;

  p {
    line-height: 28px;
  }

  @media (max-width: 992px) {
    padding: 6rem 4rem;
  }

  @media (max-width: 600px) {
    padding: 6rem 2rem;
  }
}
.job-details {
  line-height: 2rem;
  margin: 5rem 0 0 0;
  // padding: 5rem; // fix for mobile
  // background: #090c1a;
  // border: 5px #2a2256 solid;
  padding: 2.8rem;
  border-radius: 8px;

  h3,
  h4,
  h5 {
    color: #e91e63;
    margin: 3rem 0 1rem;
  }

  strong {
    font-weight: 600;
  }

  hr {
    border-top: 5px solid #161a2d;
  }

  ul {
    padding: 0;
    margin: 0;
  }
  li {
    line-height: 3rem;
    display: block;
  }

  ul span {
    background: rgba(197, 12, 79, 0.3);
    color: #e31d61;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: inline-block;
    position: relative;
    font-size: 12px;
    vertical-align: middle;
    margin-right: 15px;
  }

  li span i {
    position: absolute;
    top: 54%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  @media (max-width: 768px) {
    padding: 0rem;
  }
  @media (max-width: 600px) {
    h2 {
      font-size: 1.7rem;
      line-height: 2.4rem;
    }
    h3 {
      font-size: 1.3rem;
      line-height: 2rem;
    }
  }
}
</style>
